import { render } from "./CourseList.vue?vue&type=template&id=3f788e33&ts=true"
import script from "./CourseList.vue?vue&type=script&lang=ts"
export * from "./CourseList.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__